'use strict';
var KeyMirror = require('keymirror');
var ApplicationConstants = require('./ApplicationConstants.js');


module.exports = {
    ActionTypes: KeyMirror({
        UPDATE_INVESTMENTS_VISIBILITY: null,
        SET_ACTIVE_FUND_TYPE: null,
        START_EDIT_FUNDING_TYPE: null,
        END_EDIT_FUNDING_TYPE: null,
        CANCEL_EDIT_FUNDING_TYPE: null,
        TOGGLE_FUNDING_TYPE_VISIBILITY: null,
        UPDATE_NEW_ROLLOVER: null,
        SUBMIT_NEW_EXTERNAL_ROLLOVER: null,
        DELETE_FUNDING_TYPE: null,
        VALIDATE_FUNDING_SECTION_SETUP: null,
        SUBMIT_INTERNAL_ROLLOVER: null,
        UPDATE_EXISTING_ROLLOVER: null,
        CLEAR_NEW_FUNDING_TYPE: null,
        UPDATE_OTHER_FUNDTYPES: null,
        SUBMIT_OTHER_FUND_TYPE: null,
        END_EDIT_NON_ROLLOVER: null,
        SET_INTERNAL_ROLLOVER_INFO: null,
        UPDATE_INTERNAL_ACCOUNT_DETAILS: null,
        LOAD_SUPER_FUND_LIST: null,
        UPDATE_EXTERNAL_PREDICTIVE_DETAILS: null
    }),
    AddFundingType: [{ id: 'A', name: '+ Add funding type', isHidden: false }],
    SelectFundingTypes: [{ value: 'Internal_rollover', label: 'Internal rollover' },
        { value: 'External_rollover', label: 'External rollover' },
        { value: 'Personal_contribution', label: 'Personal contribution' },
        { value: 'Spouse_contribution', label: 'Spouse contribution' },
        { value: 'Personal_injury_payment', label: 'Personal injury payment' },
        { value: 'CGT_contribution', label: 'CGT contribution' },
        { value: 'Downsizer_contribution', label: 'Downsizer contribution'}
    ],
    FundingTypesNoInternalRollover: [
        { value: 'External_rollover', label: 'External rollover' },
        { value: 'Personal_contribution', label: 'Personal contribution' },
        { value: 'Spouse_contribution', label: 'Spouse contribution' },
        { value: 'Personal_injury_payment', label: 'Personal injury payment' },
        { value: 'CGT_contribution', label: 'CGT contribution' },
        { value: 'Downsizer_contribution', label: 'Downsizer contribution'}
    ],
    InternalRolloverTypeData: [{ id: 'entireBalance', name: 'Entire balance', isHidden: false }, { id: 'enterAmount', name: 'Enter amount', isHidden: false }, { id: 'leaveAmount', name: 'Leave amount', isHidden: false }],
    ExternalRolloverTypeData: [{ id: 'entireBalance', name: 'Entire balance', isHidden: false }, { id: 'enterAmount', name: 'Enter amount', isHidden: false }],
    Labels: [
    {
        id: ApplicationConstants.ProductIds.SUPER,
        label: 'Below please add all rollovers and contributions to fund your super.'
    },
    {
        id: ApplicationConstants.ProductIds.PENSION,
        label: 'Below please add all rollovers and contributions to fund your pension.'
    },
    {
        id: ApplicationConstants.ProductIds.INVESTMENT,
        label: 'How will this investment be made?'
    }],
    SectionNames: [
    {
        id: ApplicationConstants.ProductIds.SUPER,
        label: 'Funding your super'
    },
    {
        id: ApplicationConstants.ProductIds.PENSION,
        label: 'Funding your pension'
    },
    {
        id: ApplicationConstants.ProductIds.INVESTMENT,
        label: 'Funding your investment'
    }
    ],
    FundingTypes: KeyMirror({
        Internal_rollover: null,
        External_rollover: null,
        Personal_contribution: null,
        Spouse_contribution: null,
        Personal_injury_payment: null,
        CGT_contribution: null,
        Downsizer_contribution: null
    }),
    FundTypesLabel: {
        Internal_rollover: 'Internal rollover',
        External_rollover: 'External rollover',
        Personal_contribution: 'Personal contribution',
        Spouse_contribution: 'Spouse contribution',
        Personal_injury_payment: 'Personal injury payment',
        CGT_contribution: 'CGT contribution',
        Downsizer_contribution: 'Downsizer contribution',
        INTERNAL: 'Internal rollover',
        EXTERNAL: 'External rollover'
    },
    PensionAndSuperProducts: [{ id: 10, value: 'FirstChoice Super', label: 'FirstChoice Super' },
        { id: 50, value: 'FirstChoice Pension', label: 'FirstChoice Pension' },
        { id: 65, value: 'FirstChoice Employer', label: 'FirstChoice Employer' },
        { id: 11, value: 'FirstChoice WS Super', label: 'FirstChoice WS Super' },
        { id: 51, value: 'FirstChoice WS Pension', label: 'FirstChoice WS Pension' },
        { id: 60, value: 'Rollover & Superannuation', label: 'Rollover & Superannuation' },
        { id: 20, value: 'Personal Pension', label: 'Personal Pension' }
    ],
    InvestmentProducts: [{ id: 70, value: 'FirstChoice Investments', label: 'FirstChoice Investments' },
        { id: 91, value: 'FirstChoice Wholesale Investments', label: 'FirstChoice Wholesale Investments' },
        { id: 90, value: 'Managed Investment', label: 'Managed Investment' }
    ],
    //TODO maintain in database
    MinimumBalance: {
        10: '1500', //FirstChoice Super
        50: '0',    //FirstChoice Pension
        65: '0',    //FirstChoice Employer
        11: '1500', //FirstChoice WS Super
        51: '0',    //FirstChoice WS Pension
        60: '1500', //Rollover & Superannuation
        20: '0',    //Personal Pension
        70: '1000', //FirstChoice Investments
        91: '1000', //FirstChoice Wholesale Investments
        90: '1000'  //Managed Investment
    },
    SuperProducts: [
        { value: 'FirstChoice Super' },
        { value: 'FirstChoice Employer' },
        { value: 'FirstChoice WS Super' },
        { value: 'Rollover & Superannuation' }
    ],
    HowMuchToRollOver: {
        ENTIRE_BALANCE: 'entireBalance',
        LEAVE_AMOUNT: 'leaveAmount',
        ENTER_AMOUNT: 'enterAmount'
    },
    //model explanation:
    //summaryIndex - index of the funding type in the summary
    //productId - id of the product used in an internal rollover/transfer
    //accountNumber - account number
    //rollOverAmount - amount to be rolled over or transfered or credited or debited
    //rollOverType - type of roll over, internal, external, personal contribution, spouse contribution etc
    //rollOverName - name of funding type/rollover, the main name of the row in the summary
    //paymentMethod - method to fund rollover (bpay/direct credit/cheque/direct debit etc)
    //entireBalanceQuestion - Yes/No if transfer to insurance cover
    //isPartialRollOver - flag used to determine if the rollover is partial or not
    //remainingBalance - remaining balance left in amount, only for partial rollovers
    //partialRolloverType - type of partial rollover (leave amount or enter amount)
    //investment options - list of investment options, only for internal rollovers/transfers
    //usi - unique superannuation identifier, only for external rollovers
    //isExistingAccount - flag that indicates whether this is rollover is from an existing account
    //errorList - list of inline errors
    //errorListForSummary - list of summary errors
    //hideInvestments - flag(true/false) used to determine whether to show or hide investments in the summary
    //isEdit - flag used to determine whether to render row in the summary as edit mode
    //hideAmount - flag(true/false) used to determine whether to show or hide the amount entry fields
    //bankAccountId -  selected bank account
    //bankAccountHolderName - account holder name of selected bank account
    //bankAccountHeldOption -  Yes/No if selected bank account name is the same as applicant
    //branchNumber - selected bank account bsb,
    //startDate - earliest date to debit funds for contribution type,
    //showDdDetails - flag(true/false) used to determine whether to show/hide direct debit details
    //showDdNominateAccount - flag(true/false) used to determine whether to show/hide nominate bank account fields
    //hideBankAccountListValid - flag(true/false) used to determine whether to show/hide inline error when no bank account is selected from bank account list
    //selectedManualEntryProductId - ID of Super/Pension/Investment products in the database
    //isExternalProviderManualEntry = flag(true/false) if external provider is added through manual entry
    FundingTypeModel: {
        summaryIndex: '',
        productId: '',
        accountNumber: '',
        rollOverAmount: '',
        rollOverType: '',
        rollOverName: '',
        paymentMethod: '',
        entireBalanceQuestion: '',
        isPartialRollOver: false,
        remainingBalance: '',
        partialRolloverType: '',
        investmentOptions: [],
        otherInvestmentOptionChecked: '',
        otherInvestmentOption: '',
        usi: '',
        isExistingAccount: false,
        errorList: [],
        errorListForSummary: [],
        hideInvestments: true,
        isEdit: false,
        hideAmount: true,
        bankAccountId: '',
        accountHolderName: '',
        bankAccountHeldOption: '',
        branchNumber: '',
        startDate: '',
        showDdDetails: false,
        showDdNominateAccount: false,
        hideBankAccountListValid: true,
        showBankAccountHeldText: false,
        hideDirectDebitAddedText: true,
        selectedManualEntryProductId: '',
        isExternalProviderManualEntry: false,
        rollOverNamePredictive: '',
        internalAccountIndex: '',
        claimTaxDeduction: ''
    },
    AmountLabels: {
        SUPER_PENSION: { full: 'Full rollover', partial: 'Partial rollover' },
        INVESTMENT: { full: 'Full transfer', partial: 'Partial transfer' }
    },
    RollOverTypes: KeyMirror({
        INTERNAL: null,
        EXTERNAL: null,
        NON_ROLLOVER: null,
        ROLLOVER: null
    }),
    ConfirmSectionLabels: {
        accNo: 'Acc# ',
        entireBalance: 'This will close your existing account',
        transferInsurance: 'Transfer existing insurance (if applicable)',
        otherInvestmentOption: 'To be invested in {{product}}',
        allocatedInvestmentOption: 'To be invested according to your current allocation',
        accountDifferentNames: 'Account in different name(s)',
        completeDirectDebitForm: 'You have advised us that this account is not held in your name. Please complete the Direct Debit Authority Form.',
        completeDirectDebitFormInvestment: 'You have advised us that this account is not held in your name. Please arrange for the completion of the Direct Debit Authority Form.',
        directDebitNow: 'Funds are available now for direct debit.',
        termDepositPartialRollOver: 'As we may need to contact you regarding your term deposit we are unable to display your investment allocation at this time.'
    },
    InternalRolloverFieldMapping: {
        rollOverName: 'fypProductInternalRollover',
        partialRolloverType: 'fypInternalRolloverOption',
        rollOverAmount: 'fypInternalRolloverAmount',
        accountNumber: 'fypInternalRolloverAccountNumber',
        remainingBalance: 'fypInternalRolloverRemainingBalance',
        entireBalanceQuestion: 'fypIsEntireBalance',
        otherInvestmentOption: 'fypOtherInvestmentOption',
        maxRolloversReached: 'fypMaxRolloversError',
        maxRolloversReachedClickable: 'fundingYourProductInternalRollover'
    },
    ExternalRolloverFieldMapping: {
        rollOverName: 'fypExternalRolloverProvider',
        rollOverNamePredictive: 'fypExternalRolloverProvider2',
        partialRolloverType: 'fypExternalRolloverPartialRolloverType',
        rollOverAmount: 'fypExternalRolloverAmount',
        accountNumber: 'fypExternalRolloverAccountNumber',
        remainingBalance: 'fypExternalRolloverRemainingBalance',
        usi: 'fypExternalRollOverUsi',
        maxRolloversReached: 'fypMaxRolloversError',
        maxRolloversReachedClickable: 'fundingYourProductExternalRolloverComponent'
    },
    NonRolloverFieldMapping: {
        paymentMethod: 'fypOtherFundTypesPaymentMethod',
        claimTaxDeduction: 'fypClaimTaxDeduction',
        rollOverAmount: 'fypOtherFundTypesAmount',
        maxRolloversReached: 'fypMaxRolloversError',
        maxRolloversReachedClickable: 'fypOtherFundTypes'
    },
    DirectDebitFieldMapping: {
        paymentMethod: 'fypOtherFundTypesPaymentMethod',
        claimTaxDeduction: 'fypClaimTaxDeduction',
        rollOverAmount: 'fypDirectDebitAmountField',
        accountHolderName: 'fypAccountHolderNameText',
        bankAccountHeldOption: 'fypBankAccountHeldOption',
        branchNumber: 'fypBranchNumberText',
        accountNumber: 'fypBankAccountNumberText',
        startDate: 'fypStartDateField',
        invalidBankAccountListError: 'fypBankAccountsList',
        maxRolloversReached: 'fypMaxRolloversError',
        maxRolloversReachedClickable: 'fypOtherFundTypes'
    },
    ExternalRollOverAttributes: {
        rollOverName: 'External rollover provider',
        rollOverNamePredictive: 'External rollover provider',
        remainingBalance: 'Approximate total balance',
        partialRolloverType: 'An answer to How much would you like to rollover?',
        rollOverAmount: 'Amount',
        accountNumber: 'Account/policy number',
        usi: 'USI'
    },
    InternalRollOverAttributes: {
        rollOverName: 'Select product',
        remainingBalance: 'Approximate balance',
        partialRolloverType: 'An answer to How much would you like to rollover?',
        rollOverAmount: 'Amount',
        accountNumber: 'Account number',
        entireBalanceQuestion: 'An answer to Would you like to transfer your existing insurance cover, if applicable?',
        otherInvestmentOption: 'Other investment allocation'
    },
    InternalTransferAttributes: {
        rollOverName: 'Select product',
        remainingBalance: 'Approximate balance',
        partialRolloverType: 'An answer to How much would you like to transfer?',
        rollOverAmount: 'Amount',
        accountNumber: 'Account number',
        entireBalanceQuestion: 'An answer to Would you like to transfer your existing insurance cover, if applicable?',
        otherInvestmentOption: 'Other investment allocation'
    },
    ManualEntryInternalRolloverId: 'addProduct0',
    NonRollOverAttributes: {
        paymentMethod: 'An answer to How would you be transferring the funds?',
        claimTaxDeduction: 'An answer to Will you be claiming a tax deduction?',
        rollOverAmount: 'Amount',
        accountHolderName: 'Name of account holder',
        bankAccountHeldOption: 'An answer to Is this bank account held in the same name(s) as this application?',
        branchNumber: 'Branch number (BSB)',
        accountNumber: 'Bank account number',
        startDate: 'Earliest date funds are to be direct debited'
    },
    ContributionValues: {
        DIRECT_D: 'DD',
        BPAY: 'BPAY',
        DIRECT_C: 'DC',
        CHEQUE: 'CQ',
        INTERNAL_TRANSFER: 'IT'
    },
    ContributionTypesLabel: {
        DD: 'Direct debit',
        BPAY: 'BPAY',
        DC: 'Direct credit',
        CQ: 'Cheque',
        IT: 'Internal transfer'
    },
    //JSWR-323 Removed CQ for removal of cheque funding
    OtherContribution: {
        SUPER: [
            { id: 'DD', name: 'Direct debit', isHidden: false },
            { id: 'BPAY', name: 'BPAY', isHidden: false },
            { id: 'DC', name: 'Direct credit', isHidden: false }
            ],
        OTHERS: [
            { id: 'DD', name: 'Direct debit', isHidden: false } 
                     
            ]
    },
    NominateBankAccountId: 'nominated',
    //JSWR-323 Removed CQ for removal of cheque funding
    NoInternalTransfer: [
            { id: 'DD', name: 'Direct debit', isHidden: false },
            { id: 'BPAY', name: 'BPAY', isHidden: false },
            { id: 'DC', name: 'Direct credit', isHidden: false }            
    ],
    //JSWR-323 Removed CQ for removal of cheque funding
    WithInternalTransfer: [
            { id: 'DD', name: 'Direct debit', isHidden: false },
            { id: 'BPAY', name: 'BPAY', isHidden: false },
            { id: 'DC', name: 'Direct credit', isHidden: false },          
            { id: 'IT', name: 'Internal transfer', isHidden: false }
    ],
    selectedProductIdText: 'selectedManualEntryProductId',
    summaryLabels: {
        totalAmount: 'Total amount',
        accNo: 'acc#',
        via: 'via',
        remainingBalance: 'Remaining balance',
        internalTransfer: 'Internal transfer',
        internalRollover: 'Internal rollover',
        externalRollover: 'External rollover',
        hideInvestments: 'Hide Investments',
        showInvestments: 'Show Investments'
    },
    sectionLabels: {
        accountHolderName: 'Name of account holder',
        branchNumber: 'Branch number (BSB)',
        accountNumber: 'Account number',
        directDebitStartDate: 'Earliest date funds are to be direct debited'
    },
    InternalMonies:  {
        FCSuper: 'FirstChoice Super',
        FCPension: 'FirstChoice Pension',
        FCWSSuper: 'FirstChoice WS Super',
        FCWSPension: 'FirstChoice WS Pension', 
        FCWSPen:   'FirstChoice WS Pens'   
    },
    ExternalMomies: {
        FCEmployer:'FirstChoice Employer',
        FCRosco:'Rollover & Superannuation',
        FCPP:'Personal Pension',
        FCEmp:'FirstChoice Employ',
        FCRs:'Rollover & Super'
    },
    OnlyContributions: [
        'Personal contribution',
        'Spouse contribution',
        'Personal injury payment',
        'CGT contribution',
        'Downsizer contribution'
    ],
    MinimumAmounts: {
        pension: 20000,
        investmentNoRip: 1000,
        investmentWithRip: 1000
    },
    externalProviderId: 'fypExternalRolloverProvider',
    externalProviderManualEntry: 'isExternalProviderManualEntry',
    internalTransfer: 'IT',
    termDepositInstructionNote: 'As you have invested in term deposit(s) we may contact you for instructions.'
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./constants/FundingYourProductConstants.js